import CabinetView from "@/modules/cabinet/views/CabinetView.vue";
import AdminProductEditorPage from "@/modules/admin/products/products/views/AdminProductEditorPage.vue";
import AdminDashboard from "@/modules/admin/dashboard/views/AdminDashboard.vue";
import AdminUsersPage from "@/modules/admin/users/views/AdminUsersPage.vue";
import AdminRolesPage from "@/modules/admin/roles/views/AdminRolesPage.vue";
import AdminPermissionsPage from "@/modules/admin/permissions/views/AdminPermissionsPage.vue";
import AdminBrandsPage from "@/modules/admin/brands/views/AdminBrandsPage.vue";
import AdminCategoriesPage from "@/modules/admin/categories/views/AdminCategoriesPage.vue";
import AdminProductsPage from "@/modules/admin/products/products/views/AdminProductsPage.vue";
import AdminProductDetailsPage from "@/modules/admin/products/products/views/AdminProductDetailsPage.vue";
import AdminAttributesPage from "@/modules/admin/products/attributes/views/AdminAttributesPage.vue";
import ProductTypePage from "@/modules/admin/products/product-types/views/ProductTypePage.vue";
import ProductTypeDetailsPage from "@/modules/admin/products/product-types/views/AdminProductTypeDetailsPage.vue";
import AdminDiscountsPage from "@/modules/admin/discounts/views/AdminDiscountsPage.vue";
import AdminHomePage from "@/modules/admin/homepage/views/AdminHomePage.vue";
import ImportJobsPage from "@/modules/admin/imports/views/ImportJobsPage.vue";
import ImportJobWorkspacePage from "@/modules/admin/imports/views/ImportJobWorkspacePage.vue";
import ProductImageImportPage from "@/modules/admin/imports/views/ProductImageImportPage.vue";

const adminRouteMeta = {
  requiresAuth: true,
  permissions: [
    "ViewUsers",
    "ReviewRegistrations",
    "ManageRoles",
    "ManagePermissions",
    "EditProducts",
    "ImportProductImages",
    "EditProductTypes",
    "EditProductAttributes",
    "EditBrand",
    "EditCategory",
    "ViewDiscount",
    "EditDiscount",
    "ManageHomePage",
    "ViewHomePage",
    "EditCarousel",
    "EditWeeklySelection",
    "BlockUsers",
    "DeleteUsers",
    "EditCharacteristicValues",
    "EditVariantCharacteristics",
    "EditNotifications",
    "ChangeOrderStatus",
    "AssignOrder",
    "ReceiveOrderNotifications",
    "ViewManagersStats",
  ],
};

function permissionMeta(...permissions) {
  return {
    requiresAuth: true,
    permissions,
  };
}

export const adminRoutes = [
  {
    path: "/admin/registrations",
    name: "adminRegistrations",
    component: () => import("@/modules/admin/registrations/views/RegistrationListPage.vue"),
    meta: permissionMeta("ReviewRegistrations"),
  },
  {
    path: "/admin/registrations/:userId",
    name: "adminRegistrationDetails",
    component: () => import("@/modules/admin/registrations/views/RegistrationDetailsPage.vue"),
    meta: permissionMeta("ReviewRegistrations"),
  },
  {
    path: "/cabinet",
    name: "cabinet",
    component: CabinetView,
    meta: { requiresAuth: true },
  },
  {
    path: "/admin",
    name: "adminDashboard",
    component: AdminDashboard,
    meta: adminRouteMeta,
  },
  {
    path: "/admin/attributes",
    name: "adminAttributes",
    component: AdminAttributesPage,
    meta: permissionMeta("EditProductAttributes"),
  },
  {
    path: "/admin/attributes/:attributeId/values",
    name: "AttributeValues",
    component: () =>
      import(
        "@/modules/admin/products/attributes/views/AttributeValuesPage.vue"
      ),
    props: true,
    meta: permissionMeta("EditCharacteristicValues"),
  },
  {
    path: "/admin/users",
    name: "adminUsers",
    component: AdminUsersPage,
    meta: permissionMeta("ViewUsers"),
  },
  {
    path: "/admin/roles",
    name: "adminRoles",
    component: AdminRolesPage,
    meta: permissionMeta("ManageRoles"),
  },
  {
    path: "/admin/roles/:roleId/permissions",
    name: "adminRolePermissions",
    component: AdminPermissionsPage,
    props: true,
    meta: permissionMeta("ManagePermissions"),
  },
  {
    path: "/admin/permissions",
    name: "adminPermissions",
    component: AdminPermissionsPage,
    meta: permissionMeta("ManagePermissions"),
  },
  {
    path: "/admin/brands",
    name: "adminBrands",
    component: AdminBrandsPage,
    meta: permissionMeta("EditBrand"),
  },
  {
    path: "/admin/categories",
    name: "adminCategories",
    component: AdminCategoriesPage,
    meta: permissionMeta("EditCategory"),
  },
  {
    path: "/admin/products",
    name: "adminProducts",
    component: AdminProductsPage,
    meta: permissionMeta("EditProducts"),
  },
  {
    path: "/admin/imports",
    name: "adminImports",
    component: ImportJobsPage,
    meta: permissionMeta("EditProducts"),
  },
  {
    path: "/admin/imports/:jobId",
    name: "adminImportWorkspace",
    component: ImportJobWorkspacePage,
    props: true,
    meta: permissionMeta("EditProducts"),
  },
  {
    path: "/admin/product-image-imports",
    name: "adminProductImageImports",
    component: ProductImageImportPage,
    meta: permissionMeta("ImportProductImages"),
  },
  {
    path: "/admin/product-image-imports/:jobId",
    name: "adminProductImageImport",
    component: ProductImageImportPage,
    props: true,
    meta: permissionMeta("ImportProductImages"),
  },
  {
    path: "/admin/products/new",
    name: "adminProductNew",
    component: AdminProductEditorPage,
    meta: permissionMeta("EditProducts"),
  },
  {
  path: "/admin/products/:id/edit",
  name: "adminProductEdit",
  component: AdminProductEditorPage,
  meta: permissionMeta("EditProducts"),
  },
  {
    path: "/admin/products/:id",
    name: "adminProductDetails",
    component: AdminProductDetailsPage,
    meta: permissionMeta("EditProducts"),
  },
  {
    path: "/admin/product-types",
    name: "adminProductTypes",
    component: ProductTypePage,
    meta: permissionMeta("EditProductTypes"),
  },
  {
    path: "/admin/product-types/:id",
    name: "adminProductTypeDetails",
    component: ProductTypeDetailsPage,
    meta: permissionMeta("EditProductTypes"),
  },
  {
    path: "/admin/discounts",
    name: "adminDiscounts",
    component: AdminDiscountsPage,
    meta: permissionMeta("ViewDiscount", "EditDiscount"),
  },
  {
    path: "/admin/orders",
    name: "adminOrders",
    component: () => import("@/modules/orders/components/AdminOrdersList.vue"),
    meta: permissionMeta("ChangeOrderStatus", "AssignOrder", "ReceiveOrderNotifications"),
  },
  {
    path: "/admin/orders/:id",
    name: "adminOrderDetails",
    component: () => import("@/modules/orders/components/OrderDetails.vue"),
    meta: permissionMeta("ChangeOrderStatus", "AssignOrder", "ReceiveOrderNotifications"),
  },
  {
    path: "/admin/homepage/carousel",
    name: "adminHomepageCarousel",
    component: AdminHomePage,
    meta: permissionMeta("EditCarousel"),
  },
  {
    path: "/admin/homepage/weekly-selection",
    name: "adminHomepageWeeklySelection",
    component: () =>
      import("@/modules/admin/homepage/views/AdminWeeklySelection.vue"),
    meta: permissionMeta("EditWeeklySelection"),
  },
  {
    path: "/admin/top-managers",
    name: "adminTopManagers",
    component: () => import("@/modules/admin/stats/views/TopManagersPage.vue"),
    meta: permissionMeta("ViewManagersStats"),
  }
];
